/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import * as React from "react";
// Custom CSS
import "../../../assets/css/custom.css";
import sign from "../../../assets/images/sign.png";

const HeadingText = styled("div")({
  color: "#0A0A0A",
  backgroundColor: "transparent",
  padding: 1,
  textTransform: "uppercase",
  opacity: "0.8",
  fontWeight: "400",
  fontFamily: "inherit",
});
function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container id="testimonial">
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          {" "}
          <MKTypography variant="h2">
            <HeadingText className="heading-bg" sx={{ fontWeight: "bold" }}>
              Testimonials
            </HeadingText>
          </MKTypography>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div className="card testimonials-card">
              <div className="d-flex justify-content-center ">
                <img
                  className="testimonials"
                  src="https://snlc-files.s3.ap-south-1.amazonaws.com/testimonials/vr_krishna_iyer.jpg"
                  alt="sample"
                />
              </div>
              <div className="card-body text-center">
                <h4> Honourable Mr. Justice V. R. Krishna Iyer</h4>
                <h6>Retired Judge, Supreme Court of India</h6>
                <hr />
                <p>
                  "Law lives awfully in the villages of India. That is why I am proud that this law
                  College in the rural areas of Poothotta serves the rule of law better than big Law
                  Colleges in the City. You have a fine library which is a great asset for the rural
                  community. If the villages become law conscious and the villagers become aware of
                  the law of the country Law India becomes a powerful legal community and united
                  fraternity. I wish the Poothotta Law College a great future ahead and convert the
                  rural wonder of Poothotta a strong legal power which will guardian the integrity
                  and humanity. Of course of the divinity of India that is Bharat. Not the verbal
                  vigour of the Constitution but the paramount power of the clauses of the
                  Constitution that makes the country strong and its people a truly socialist
                  democratic Republic. I will be glad to be the Chief Patron of your College. But
                  emphatically insist that you will sacrifice all your strength for the paramount
                  purpose of making India the great country you have inherited from your ancestors."
                </p>
                <div className="row d-flex justify-content-center">
                  <div className="col-md-4">
                    <img src={sign} alt="V.R Krishna Iyer" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
